const IPFS_PREFIX = 'ipfs://';

export const translateIpfsToPinata = (uri: string) => {
  const isIpfs = uri.startsWith(IPFS_PREFIX);
  if (!isIpfs) {
    throw new Error('I only know how to handle IPFS');
  }
  return `https://mogul.mypinata.cloud/ipfs/${uri.slice(IPFS_PREFIX.length)}`;
};
